export default __webpack_public_path__ + "static/media/Helm of the Victorious Elite.24ca0a94.jpg";